import { InventoryBundleFragment } from '@control-tower/platform-wms';

export type CpwPackageType = 'box' | 'pallet';

export const CpwPackingCustomFields = {
    PackageType: 'PackageType',
} as const;

export type CpwPackingItem = {
    itemId: string;
    projectLineItemId?: string;
    bundles: InventoryBundleFragment[];
    itemDescription: string;
    quantityToPack: number;
};
